// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SocialActionsMenu-cls1___192735641f5f9c648b7{/*!*/}.SocialActionsMenu-cls2__dd5bd990ae9b543ad069{display:flex;grid-gap:6px;gap:6px;color:#535366;padding:12px 16px;white-space:nowrap;min-width:240px}@media(min-width: 768px){.SocialActionsMenu-cls2__dd5bd990ae9b543ad069{min-width:320px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SocialActionsMenu-cls1___192735641f5f9c648b7",
	"cls2": "SocialActionsMenu-cls2__dd5bd990ae9b543ad069 SocialActionsMenu-cls1___192735641f5f9c648b7"
};
export default ___CSS_LOADER_EXPORT___;
